import React from 'react'
import { Link } from 'react-router-dom'

function TopHead() {
  return (
    <>
      <div className='container-fluid py-2 py-sm-0 py-lg-1 border-bottom top-head-bg'>
        <div className='container-lg'>
          <div className='row'>
            <div className='col-lg-10 col-md-9 col-sm-12 col-12 align-self-center py-sm-2 py-md-0'>
              <div className='d-flex gap-3 px-1'>
                <div className=' top-Nav-contact '>
                  <Link to="tel:+91 9729170195"> <i className="fa-solid fa-phone" style={{ color: "#fff" }}></i> +91 9729170195</Link>
                </div>
                <div className=' top-Nav-contact top-Nav-contact-hide1 '>
                  <Link to="mailto:waywys.it@gmail.com"><i className="fa-solid fa-envelope" style={{ color: "#fff" }}></i> waywys.it@gmail.com</Link>
                </div>
              </div>
            </div>
            <div className='top-Nav-contact-hide col-lg-2 col-md-3 col-sm-12   justify-content-sm-end d-flex gap-3 justify-content-center align-items-center top-nav-content'>
              <Link to="https://www.linkedin.com/company/waywys/" target="_blank" className="social-icon-nav"><i className="fa-brands fa-linkedin"></i></Link>
              {/* <Link to="https://www.instagram.com/webtechsolutionsservice/" target="_blank" className="social-icon-nav"><i className="fa-brands fa-instagram"></i></Link>
              <Link to="https://www.facebook.com/webtechsolutionsservice" target="_blank" className="social-icon-nav"><i className="fa-brands fa-square-facebook"></i></Link>
              <Link to="https://twitter.com/webtechpvtltd" target="_blank" className="social-icon-nav"><i className="fa-brands fa-square-x-twitter"></i></Link>
              <Link to="https://in.pinterest.com/webtechsolutionsservice/" target="_blank" className="social-icon-nav"><i className="fa-brands fa-pinterest-p"></i></Link>
              <Link to="https://www.youtube.com/@webtechsolutionsservice" target="_blank" className="social-icon-nav"><i className="fa-brands fa-youtube"></i></Link> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TopHead